import * as React from 'react';
import Modal from "../../_commonComponents/ModalForm";
import {Field} from "redux-form";
import renderInput from "../../_commonComponents/form/InputWithValidation";
import {PHONE_MASK} from "../../../config/constants";
import {required, email} from "../../../utils/formValidation";

const AddNewUserForm = ({isOpen, toggle, onSubmit, form}) => (
    <Modal
        toggle={toggle}
        isOpen={isOpen}
        title={'Новый пользователь'}
        form={form}
        header
        color={"primary"}
        onSubmit={onSubmit}
    >
        <Field
            component={renderInput}
            name={'name'}
            type="text"
            label={'Имя'}
        />
        <Field
            component={renderInput}
            name={'title'}
            type="text"
            label={'ФИО'}
            validate={[required]}
        />
        <Field
            component={renderInput}
            name={'phone'}
            type="text"
            label={'Номер телефона'}
            mask={PHONE_MASK}
            validate={[required]}
        />
        <Field
            component={renderInput}
            name={'email'}
            type="text"
            label={'Электронная почта'}
            validate={[email]}
        />
    </Modal>
);

export default AddNewUserForm;
